/** Ranked Quick Matches that fill today's ladder. Step 10 is two shop packs. */
export const RANKED_DAILY_COUNT = 10

/** Steps that pay coins. Step 10 pays two shop packs and no coins. */
export const RANKED_COIN_STEPS = 9

/** Coins paid by each of those steps. */
export const RANKED_STEP_COINS = 3

/** Shop pack granted when this many Quick Matches are finished today. */
export const RANKED_MID_PACK_STEP = 7

/** Shop packs granted on step 10. */
export const RANKED_FINAL_PACKS = 2

/**
 * Coins paid when that step is reached. Steps 1–9 pay 3.
 * Step 7 also grants one shop pack. Step 10 grants two shop packs and no coins.
 */
export function rankedStepCoins(step: number): number {
  if (!Number.isInteger(step) || step < 1 || step > RANKED_COIN_STEPS) return 0
  return RANKED_STEP_COINS
}

/** Shop packs granted when that step is reached. Step 7 is 1, step 10 is 2. */
export function rankedStepPacks(step: number): number {
  if (step === RANKED_MID_PACK_STEP) return 1
  if (step === RANKED_DAILY_COUNT) return RANKED_FINAL_PACKS
  return 0
}

/** True when finishing that step grants a shop pack. */
export function rankedStepGivesPack(step: number): boolean {
  return rankedStepPacks(step) > 0
}

/** Claim buttons still waiting. Every finished step has a reward. */
export function rankedPendingCount(played: number, collected: number): number {
  const done = clampRankedCount(played)
  const claimed = Math.min(clampRankedCount(collected), done)
  return done - claimed
}

export function clampRankedCount(value: unknown): number {
  if (typeof value !== 'number' || !Number.isFinite(value)) return 0
  const n = Math.trunc(value)
  if (n <= 0) return 0
  return n > RANKED_DAILY_COUNT ? RANKED_DAILY_COUNT : n
}

export type RankedDailyState = {
  played: number
  collected: number
  /** Shop pack for step 10. */
  packGranted: boolean
  /** Shop pack for step 7. */
  midPackGranted: boolean
}

export function normalizeRankedDaily(
  played: unknown,
  collected: unknown,
  packGranted: unknown,
  midPackGranted: unknown = false,
): RankedDailyState {
  const nextPlayed = clampRankedCount(played)
  return {
    played: nextPlayed,
    collected: Math.min(clampRankedCount(collected), nextPlayed),
    packGranted: packGranted === true && nextPlayed >= RANKED_DAILY_COUNT,
    midPackGranted: midPackGranted === true && nextPlayed >= RANKED_MID_PACK_STEP,
  }
}
